import * as React from 'react';
import { Helmet } from 'react-helmet';

function PageStyle({ meta, styles }) {
  const socialDescription = meta?.description || meta.socialTitle;
  return (
    <Helmet
      meta={[
        {
          property: `og:description`,
          content: `${socialDescription}`,
        },
        {
          property: `og:image`,
          content: `${meta.imgLocation}${meta.socialImg}`,
        },
        {
          property: `og:image:width`,
          content: `${meta.socialImgWidth}`,
        },
        {
          property: `og:image:height`,
          content: `${meta.socialImgHeight}`,
        },
        {
          property: `og:image:type`,
          content: `${meta.socialImgType}`,
        },
        {
          name: `twitter:description`,
          content: `${socialDescription}`,
        },
        {
          name: `twitter:image`,
          content: `${meta.imgLocation}${meta.socialImg}`,
        },
      ]}
      style={[
        {
          cssText: `
          .hero {
            ${
              styles.bannerColor
                ? `background-color: #${styles.bannerColor};`
                : ``
            }
          }
          .content h2, .content h3, .content h4 {
            ${styles.headingsColor ? `color: #${styles.headingsColor};` : ``}
            ${
              styles.headingsFont
                ? `font-family: '${styles.headingsFont}', 'Times New Roman', serif;`
                : ``
            }
          }
          .content h2 {
            ${styles.h2FontSize ? `font-size: ${styles.h2FontSize};` : ``}
          }
          .content.container h3 {
            ${styles.h3FontSize ? `font-size: ${styles.h3FontSize};` : ``}
          }
          .content.container h4 {
            ${styles.h4FontSize ? `font-size: ${styles.h4FontSize};` : ``}
          }
          .content img {
            ${
              styles.imgBorderColor
                ? `
            border: 2px solid #${styles.imgBorderColor};
            `
                : ``
            }
          }`,
        },
      ]}
    ></Helmet>
  );
}

export default PageStyle;
